var Backbone = require('backbone');
var _ = require('lodash');
var template = require('../templates/modal.ejs');
var PubSub = require('tscom-pubsub');

module.exports = Backbone.View.extend({
    tagName: 'div',
    className: 'view-modal',
    events: {
        'click .btn-close': 'close'
    },
    /**
     *
     */
    initialize: function(options) {
        this.router =
            typeof options.model.view.controller !== 'undefined'
                ? options.model.view.controller.Routers.Router
                : options.model.view.router;
        this.listenTo(PubSub, 'close-modal', this.close.bind(this));
    },
    /**
     *
     */
    render: function() {
        this.$el.html(template());
        this.$el.append(
            _.isObject(this.model.view)
                ? this.model.view.render().$el
                : this.model.view
        );
        return this;
    },
    /**
     *
     */
    close: function() {
        this.router.closeCurrentModal();
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/standard-vote/app/scripts/views/modal.js
// module id = 242
// module chunks = 0